import {Platform} from "@variocube/app-api";
import {DateTime} from "luxon";
import {ClearingStatus, CubeOrder, OrderStatus, OrderStorage, OrderType} from "./model";


function createMockOrder(id: number, accessCode: string, orderStatus: OrderStatus, clearingStatus?:ClearingStatus): CubeOrder {
    return {
        orderId: id,
        orderIdPrint: "orderNo" + id,
        orderDate: DateTime.local().toMillis(),
        email: "peter.karrer@onlinegroup.at",
        orderStatus: orderStatus,
        person: {
            firstname: "Peter",
            lastname: "Karrer",
            title: "",
            salutation: "Herr"
        },
        orderType: OrderType.Cleaning,
        accessCode,
        clearingStatus
    };
}

export async function loadMockData(platform: Platform) {

    const orders = [
        createMockOrder(1, "1", OrderStatus.Ordered),
        createMockOrder(2, "2", OrderStatus.WaitingPickup),
        createMockOrder(3, "3", OrderStatus.Cleaning),
        createMockOrder(4, "4", OrderStatus.WaitingReturn),
        createMockOrder(5, "5", OrderStatus.WaitingReturn, ClearingStatus.Success),
        createMockOrder(6, "6", OrderStatus.Completed),
    ];

    for (let order of orders) {
        if (order.orderStatus == OrderStatus.WaitingPickup || order.orderStatus == OrderStatus.WaitingReturn) {
            const occupancy = await platform.occupy({
                type: "SuitBag",
                accessCode: order.accessCode,
                content: { order },
            });
            await platform.confirmOccupancy(occupancy.uuid);
        }
    }

    return {
        cleaner: {
            accessCode: "999",
            requiredWelcomePackages: 400,
            cleanerCompany: "Demoreiniger"
        },
        orders: orders.reduce((prev, curr) => {
            prev[curr.accessCode] = curr;
            return prev;
        }, {} as OrderStorage)
    }
}

